import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resolveLocalizedText } from '../../../../utils';
import { ChangeContactView } from '../../components/ChangeContactView';
import {
  getChangeEmailLabels,
  getChangeEmailStepContext,
  getGoGreenList,
} from '../../selectors/changeEmailSelector';
import './style.scss';
import { goto } from '../../../../actions/historyActions';
import { getSelectedPolicy } from '../../selectors/changeContactSelector';
import { sortPermissionPolicies } from '../../utils';
import { contactPermissionPolicy } from '../../types/changeContactService';
import _ from 'lodash';

export interface GoGreenContainerContainerProps {
  changeEmailLabels: any;
  changeEmailStepContext: any;
  policyDetails: any;
  goGreenList: contactPermissionPolicy[];
}

export interface GoGreenContainerContainerState {}

export class GoGreenContainerContainer extends Component<
  GoGreenContainerContainerProps,
  GoGreenContainerContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  onGoNext = async () => {
    goto('emma-customer-profile/changeemail/review');
  };

  componentDidMount() {
    const { policyDetails } = this.props;
    if (_.isEmpty(policyDetails)) {
      goto('emma-change-contact', undefined, undefined, true);
    }
  }

  render() {
    const { changeEmailLabels, changeEmailStepContext, goGreenList } =
      this.props;
    const editEmail = resolveLocalizedText(changeEmailLabels.editEmail);
    const resolvedStepContext = resolveLocalizedText(
      changeEmailStepContext,
    ) as any;
    const goGreenHeading = resolveLocalizedText(
      changeEmailLabels.goGreenHeading,
    );
    const goGreenDisclaimer = resolveLocalizedText(
      changeEmailLabels.goGreenDisclaimer,
    );
    const goGreenListLabel = resolveLocalizedText(
      changeEmailLabels.goGreenListLabel,
    );
    const agreeGoGreen = resolveLocalizedText(changeEmailLabels.agreeGoGreen);

    return (
      <div className="Email-Go-Green">
        <ChangeContactView
          pageName={editEmail}
          stepContext={resolvedStepContext}
          activeIndex={1}
        >
          <div className="emma-stylesheet-grid-system">
            <div className="change-contact-heading">{goGreenHeading}</div>
            <div className="change-contact-label go-green-disclaimer">
              {goGreenDisclaimer}
            </div>
            <div className="change-contact-label--bold">{goGreenListLabel}</div>
            <div className="change-contact-label go-green-list">
              <ul>
                {sortPermissionPolicies(goGreenList).map(
                  ({ planName, policyName }) => {
                    return (
                      <li>
                        {resolveLocalizedText(planName || policyName || '')}
                      </li>
                    );
                  },
                )}
              </ul>
            </div>
            <div className="row">
              <button
                className={
                  'Email-Go-Green__button col-4 emma-stylesheet-primary-default-button'
                }
                data-enable-ga
                data-ga-type="button"
                onClick={this.onGoNext}
              >
                {agreeGoGreen}
              </button>
            </div>
          </div>
        </ChangeContactView>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeEmailLabels = getChangeEmailLabels(state);
    const changeEmailStepContext = getChangeEmailStepContext(state);
    const policyDetails = getSelectedPolicy(state);
    const goGreenList = getGoGreenList(state);

    return {
      changeEmailLabels,
      changeEmailStepContext,
      policyDetails,
      goGreenList,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  GoGreenContainerContainer.mapStateToProps,
  GoGreenContainerContainer.mapDispatchToProps,
)(GoGreenContainerContainer);
